<div class="status-tag">
  <div class="status-content">
    @if (title) {
      <div class="status-title">{{ title }}</div>
    }

    @if (date || time) {
      <div class="status-datetime">
        @if (date) {
          <span>{{ date }}</span><br/>
        }
      </div>
      <div class="status-datetime">
        @if (time) {
          <span> {{ time }}</span>
        }
      </div>
    }
  </div>
</div>
